import { render, staticRenderFns } from "./x-results-grid.component.vue?vue&type=template&id=fe7b325e&scoped=true"
import script from "./x-results-grid.component.vue?vue&type=script&lang=ts"
export * from "./x-results-grid.component.vue?vue&type=script&lang=ts"
import style0 from "./x-results-grid.component.vue?vue&type=style&index=0&id=fe7b325e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7b325e",
  null
  
)

export default component.exports